import { computed as e } from "vue";
var x = /* @__PURE__ */ ((t) => (t.xs = "--hobi-space-xs", t.s = "--hobi-space-s", t.m = "--hobi-space-m", t.l = "--hobi-space-l", t.xl = "--hobi-space-xl", t.xxl = "--hobi-space-xxl", t.xxxl = "--hobi-space-3xl", t.xxxxl = "--hobi-space-4xl", t))(x || {});
const r = (t, c) => {
  switch (t) {
    case "":
      return "";
    case "xs":
      return `tw-m${c}-1`;
    case "s":
      return `tw-m${c}-2`;
    case "m":
      return `tw-m${c}-4`;
    case "l":
      return `tw-m${c}-6`;
    case "xl":
      return `tw-m${c}-8`;
  }
};
function a(t) {
  const c = e(() => t.topSpacing ? `hobi-mtop--${t.topSpacing}` : ""), n = e(() => t.bottomSpacing ? `hobi-mbottom--${t.bottomSpacing}` : ""), s = e(() => `hobi-mbottom--${t.bottomSpacing} hobi-mtop--${t.topSpacing}`), m = e(() => t.leftSpacing ? `hobi-mleft--${t.leftSpacing}` : ""), o = e(() => t.rightSpacing ? `hobi-mright--${t.rightSpacing}` : "");
  return {
    topSpacingClass: c,
    bottomSpacingClass: n,
    topAndBottomSpacing: s,
    leftSpacingClass: m,
    rightSpacingClass: o
  };
}
export {
  x as SpacingHobiVariable,
  r as getSpacingClass,
  a as useSpacingClass
};
